import NTTApp from './NTTAssessment';
import VendorPortal from './VendorPortal';
import StudentApp from './StudentApp';
import ApprovePage from './ApprovePage';
import RavishaWhatsApp from './RavishaWhatsApp';
import TextZoom from './TextZoom';

export default function App() {
  // Path with leading/trailing slashes stripped: "" (root), "tuap", "vendors",
  // "approve", "student", or a student slug like "firstname-lastname-xxxxx".
  const path = window.location.pathname.replace(/^\/+|\/+$/g, "").toLowerCase();

  // Admin section paths — everything under /admin/* plus a handful of
  // friendly aliases ("/whatsapp", "/communication(s)", "/trusted-partners").
  // NTTApp parses the URL itself and switches into the matching sub-view.
  const isAdminPath = path === "admin" || path.startsWith("admin/")
    || path === "tuap"
    || path === "whatsapp" || path === "communication" || path === "communications"
    || path === "trusted-partners" || path === "partners";

  // Onboarding moved to the new wizard (onboarding.neerajmandhana.com). The TUAP
  // welcome email links to fm.neerajmandhana.com/<student-slug>, so redirect any
  // such student onboarding link straight to the new form (DK 19 Jul). Keep the
  // query-based portal access (/student?id=&t=) working.
  const isStudentSlug = path && path !== "student" && !isAdminPath
    && path !== "vendors" && path !== "approve" && path !== "ravisha-wa"
    && !path.startsWith("essay/");
  if (isStudentSlug && typeof window !== "undefined") {
    window.location.replace("https://onboarding.neerajmandhana.com/?from=" + encodeURIComponent(path));
    return null;
  }

  let page;
  if (path === "vendors") page = <VendorPortal />;
  else if (path === "approve") page = <ApprovePage />;
  else if (path === "ravisha-wa") page = <RavishaWhatsApp />;
  else if (path.startsWith("essay/")) page = <StudentApp forcedSlug={path.slice(6)} essayOnly />;
  else if (path === "" || isAdminPath) page = <NTTApp />;
  else page = <StudentApp />;

  return (
    <>
      {page}
      {/* Global UI zoom — fixed pill bottom-right, scales the whole site. */}
      <TextZoom />
    </>
  );
}
